import { z } from 'zod'
import { optionalString, requiredString } from '../primitives'

// Forma REAL (shared/schemas/last-name.ts): { first, second?, married? }
export const LastNameSchema = z.object({
  first: requiredString(),
  second: optionalString(),
  married: optionalString()
})

export type LastName = z.infer<typeof LastNameSchema>
